import { useTranslation } from "react-i18next";
import { GetOneExpeditionBoResponseDto } from "@/types/api/api-types";
import { InfoAccordionRow, InfoRowNested } from "./infoCard";
import { getFullName } from "./expeditionDetail.utils";

/** User who created the expedition. */
export const UserAccordion = ({ expedition }: { expedition: GetOneExpeditionBoResponseDto }) => {
  const { t } = useTranslation(["boExpeditions", "common"]);
  const createdBy = expedition.createdBy;
  const contactName = getFullName(createdBy?.firstName, createdBy?.lastName);

  return (
    <InfoAccordionRow label={t("expeditionDrawerDetails.user")} value={contactName}>
      {createdBy && (
        <>
          <InfoRowNested label={t("expeditionDrawerDetails.email")} value={createdBy.email} />
          <InfoRowNested
            label={t("expeditionDrawerDetails.mobilePhone")}
            value={createdBy.mobilePhoneNumber}
          />
          {createdBy.fixedPhoneNumber && (
            <InfoRowNested
              label={t("expeditionDrawerDetails.landlinePhone")}
              value={createdBy.fixedPhoneNumber}
            />
          )}
        </>
      )}
    </InfoAccordionRow>
  );
};
